<template>
  <div class="searchPage">
    <div class="search">
      <input class="search_text" type="text" placeholder="搜索作品名称" v-model="searchval" @keyup="e => { keyupSearch(e) }">
      <span class="search_btn" @click="handleSearch">搜索</span>
    </div>
    <div class="searchCon" v-show="HistoryList.length > 0">
      <div v-for="(item, index) in HistoryList " :key="index" @click="navToDetail(item.comicId)"
        :class="[(index + 1) % 5 == 0 ? 'searchCon_noMargin' : '', 'searchCon_item']">
        <img  @dragstart.prevent  :src="item.realCoverUrl" alt="">
        <p class="searchCon_tit" v-html="item.comicName"></p>
      </div>
    </div>
    <div v-show="HistoryList.length == 0" class="nomarl flex-center">
    <img  @dragstart.prevent  src="../assets/img_kongshujv.png" alt="">
      暂无数据</div>
  </div>
</template>
<script setup>
import { navToDetail } from '../utils/utils'
import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router'
import {searchApi} from '@/utils/api'
let route = useRoute()
let router = useRouter()
let searchval = ref('')

//观看历史
let HistoryList = ref([])

onMounted(()=>{
  searchval.value = route.query.searchval
  handleSearch()
})
let keyupSearch = (event => {
  if (event.keyCode === 13) {
  }
})
let handleSearch = () => {
  searchApi({value: searchval.value}).then(res=>{
    let arr = res.data
    if(arr.length>0){
      var reg = new RegExp(searchval.value, 'ig')
      HistoryList.value = arr.map(item => {
        var res = "<span style='color:#CB2945'>" + searchval.value + "</span>"
        item.comicName = item.comicName.replace(reg, res)
        return item
      })
    }else{
      HistoryList.value = []
    }
  })



  return

}

</script>

<style lang="scss" scoped>
.searchPage {
  width: 1188px;
  margin: 40px auto 60px;

  .search {
    position: relative;

    &_text {
      width: 1188px;
      height: 84px;
      background: #FFFFFF;
      border-radius: 10px;
      border: none;
      outline: none;
      border: 2px solid #E6E6E6;
      padding: 0 20px;
      box-sizing: border-box;
      margin-bottom: 60px;

      & ::placeholder {
        font-size: 16px;
        font-weight: 400;font-weight: lighter;
        color: #333333;
        line-height: 24px;

      }
    }

    &_btn {
      display: inline-block;
      cursor: pointer;
      width: 100px;
      height: 38px;
      background: #CB2945;
      border-radius: 19px;
      font-size: 20px;
      text-align: center;
      
      color: #FFFFFF;
      line-height: 38px;
      position: absolute;
      right: 20px;
      top: 15%;
    }
  }

  .searchCon {
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    &_item {
      width: 200px;
      height: auto;
      margin: 0 47px 30px 0;

      img {
        width: 200px;
        height: 300px;
        border-radius: 10px;
      }
    }

    &_noMargin {
      margin-right: 0;
    }

    &_tit {
      width: 200px;
      font-size: 18px;
      
      color: #333333;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

  }
  .nomarl {
    margin: 0 0 40px;
    text-align: center;
    font-size: 16px;
    color: #999999;
    line-height: 20px;
    flex-direction: column;
    img{
      width: 300px;
      height: 300px;
    }
  }

}
</style>